﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';
import TKArticleList from '@tk/components/tk.article.list';
import showDimmer from '@tk/utilities/tk.dimmer';
import render from '@tk/utilities/tk.render';
import { getCurrentURI, removePersistentView } from '@tk/utilities/tk.storage';

export default class TKArticleListSort extends TKCustomElementFactory {
    buttons: NodeListOf<HTMLButtonElement>;
    action: string;
    sortFieldName: string;
    articleList?: TKArticleList;
    headerElement?: HTMLElement;
    gridElement?: HTMLElement;
    pagingElement?: HTMLElement;

    constructor() {
        super();

        this.buttons = this.querySelectorAll('button');
        this.action = this.getAttribute('data-tk-action') || window.location.href;
        this.sortFieldName = this.getAttribute('data-tk-article-list-sort-name') || 'field-sort';
        this.articleList = document.querySelector('[data-tk-article-list-to-sort]') || undefined;
        this.headerElement = this.articleList?.querySelector('[data-tk-article-list-header]') || undefined;
        this.gridElement = this.articleList?.querySelector('[data-tk-article-list-grid]') || undefined;
        this.pagingElement = this.articleList?.querySelector('[data-tk-article-list-paging]') || undefined;
    }

    connectedCallback(): void {
        if (!this.articleList) throw new Error('TKArticleListSort: Article list is missing!');
        this.registerClickListener();
    }

    registerClickListener() {
        const onClick = this.sortList.bind(this);
        this.buttons.forEach((button) => {
            this.pushListener({ event: 'click', element: button, action: onClick });
        });
    }

    sortList(event: Event) {
        if (!event.target) return;
        const { value } = event.currentTarget as HTMLButtonElement;
        const data = {
            [this.sortFieldName]: value,
            originalUrl: window.location.href,
        };
        const dimmer = showDimmer();
        fetchRequest({
            requestURL: this.action,
            resolveHandler: this.refreshResultList.bind(this),
            payload: data,
        }).finally(() => {
            this.remove();
            dimmer.remove();
        });
    }

    refreshResultList(response: TKResponse) {
        if (!response || !response.success) return;
        const html = render(response.dataAsHtml);
        const headerElement = html.querySelector('[data-tk-article-list-header]');
        const gridElement = html.querySelector('[data-tk-article-list-grid]');
        const pagingElement = html.querySelector('[data-tk-article-list-paging]');
        if (headerElement) this.headerElement!.innerHTML = headerElement.innerHTML;
        if (gridElement) this.gridElement!.innerHTML = gridElement.innerHTML;
        if (this.pagingElement && pagingElement) {
            this.pagingElement.innerHTML = pagingElement.innerHTML;
        }
        removePersistentView(getCurrentURI());
    }
}
